import React from "react";
import SupportLayout from "../support/SupportLayout";
import ProgressContent from "../support-officer/components/ProgressContent";
import useSupportOfficerData from "../support-officer/hooks/useSupportOfficerData";

const SupportExecutiveProgressWrapper = () => {
  const {
    progressData,
    loading,
    getDefaultDates,
    fetchProgressDashboard,
    orders,
    pagination,
    fetchOrders,
  } = useSupportOfficerData();

  return (
    <SupportLayout userRole="SE">
      <ProgressContent
        useOwnLayout={true}
        showFilter={true}
        filterType="team"
        externalData={progressData}
        externalLoading={loading}
        externalGetDefaultDates={getDefaultDates}
        externalFetchData={fetchProgressDashboard}
        externalFetchOrders={fetchOrders}
        externalOrders={orders}
        externalPagination={pagination}
        userRole="SE"
      />
    </SupportLayout>
  );
};

export default SupportExecutiveProgressWrapper;
